import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'onboardingPages.clientOnboarding.healthIssuesStep.description',
    defaultMessage:
      'By providing us with this info, we will always take special care of you by providing info what could be potentially harmful for your state and what is beneficial too!',
  },
  submitError: {
    id: 'onboardingPages.clientOnboarding.healthIssuesStep.submitError',
    defaultMessage: "We couldn't complete your profile. Please try again.",
  },
  title: {
    id: 'onboardingPages.clientOnboarding.healthIssuesStep.title',
    defaultMessage: 'Any Health issues?',
  },
});

export default messages;
